import { render, staticRenderFns } from "./Apostas.vue?vue&type=template&id=49cfa30c&scoped=true"
import script from "./Apostas.vue?vue&type=script&lang=js"
export * from "./Apostas.vue?vue&type=script&lang=js"
import style1 from "./Apostas.vue?vue&type=style&index=1&id=49cfa30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cfa30c",
  null
  
)

export default component.exports